import { render } from "./signDialog.vue?vue&type=template&id=0abba6ce&scoped=true"
import script from "./signDialog.vue?vue&type=script&lang=js"
export * from "./signDialog.vue?vue&type=script&lang=js"

import "./signDialog.vue?vue&type=style&index=0&id=0abba6ce&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abba6ce"]])

export default __exports__